var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 95.8333C26.846 90.6875 8.3335 68.8417 8.3335 45.8333V20.8333L50.0002 4.16666L91.6668 20.8333V45.8333C91.6668 68.85 73.1543 90.6875 50.0002 95.8333ZM16.6668 25V45.8333C16.9049 55.4672 20.2933 64.7576 26.3134 72.2827C32.3335 79.8078 40.6535 85.1529 50.0002 87.5C59.3468 85.1529 67.6669 79.8078 73.6869 72.2827C79.707 64.7576 83.0954 55.4672 83.3335 45.8333V25L50.0002 12.5L16.6668 25Z",
    fill: "#FF5001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 45.8333C55.7531 45.8333 60.4168 41.1696 60.4168 35.4167C60.4168 29.6637 55.7531 25 50.0002 25C44.2472 25 39.5835 29.6637 39.5835 35.4167C39.5835 41.1696 44.2472 45.8333 50.0002 45.8333Z",
    fill: "#FF5001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 62.5C31.2202 66.2425 34.2315 69.3721 37.8921 71.5685C41.5527 73.7648 45.7312 74.9491 49.9998 75C54.2685 74.9491 58.447 73.7648 62.1076 71.5685C65.7682 69.3721 68.7795 66.2425 70.8332 62.5C70.729 54.6 56.9082 50 49.9998 50C43.054 50 29.2707 54.6 29.1665 62.5Z",
    fill: "#FF5001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLoginLogo);
export default __webpack_public_path__ + "static/media/AdminLoginLogo.01f642ac004a9c98e4359cff88a5e2fd.svg";
export { ForwardRef as ReactComponent };